// @owners { team: patient-health }
import { type BACKGROUND_COLORS_VALUES } from '@alto/design-library-tokens';
import { AltoIcon, PresentationListItem } from '@alto/design-system';
import { type Address as HomescreenAddress } from '@alto/scriptdash/alto/patient_app/homescreen/types/v1/address';
import React from 'react';
import { type ShortAddressOptions, formatShortAddress } from '~shared/helpers/address';
import { type Address } from '~shared/types';

type LocationProps = {
  readonly address?: Address | HomescreenAddress | ShortAddressOptions | string;
  readonly backgroundColor?: BACKGROUND_COLORS_VALUES;
  readonly isPickup?: boolean;
};

export const LocationRow = ({ address, backgroundColor, isPickup }: LocationProps) => (
  <PresentationListItem
    data-testid="location-row"
    LeftContent={
      <AltoIcon
        name="mapmarker"
        type="grey"
      />
    }
    text={`${isPickup ? 'Alto Pharmacy, ' : ''}${typeof address === 'string' ? address : formatShortAddress(address)}`}
    backgroundColor={backgroundColor}
  />
);
